import React, { useContext, useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import Footer from "./Footer";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import Header from "./Header";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState("");
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [selectedColor, setSelectedColor] = useState("");

  useEffect(() => {
    if (product?.size?.[0]) {
      setSelectedSize(product.size[0]);
    }
  }, [product]);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <Header />
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const handleAddToCart = () => {
    // If product has sizes, require a selection
    if (product.size && product.size.length > 0 && !selectedSize) {
      alert("Please select a size");
      return;
    }
    // encode color into size string if color exists so cart can distinguish
    const sizeKey = product.color
      ? `${selectedSize || ""}|${selectedColor || ""}`
      : selectedSize || selectedColor || "";
    addToCart(product.id, quantity, sizeKey);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="product-detail">
      <Header />
      <main className="product-detail__main">
        <section className="product-detail__media">
          <div className="product-detail__image-wrap">
            <img
              className="product-detail__image"
              src={product.images?.[selectedImage] || product.image}
              alt={product.name}
            />
          </div>

          {product.images && product.images.length > 1 && (
            <div className="product-detail__thumbs">
              {product.images.map((src, idx) => (
                <button
                  key={idx}
                  className={`product-detail__thumb ${
                    selectedImage === idx ? "is-active" : ""
                  }`}
                  onClick={() => setSelectedImage(idx)}
                  aria-label={`Show image ${idx + 1}`}
                >
                  <img src={src} alt={`${product.name} ${idx + 1}`} />
                </button>
              ))}
            </div>
          )}
        </section>

        <aside className="product-detail__info">
          <h1 className="product-detail__title">{product.name}</h1>
          <div className="product-detail__meta">
            <div className="product-detail__price">${product.price}</div>
            <div className="product-detail__rating">
              {product.rating} ★ • {product.reviews} reviews
            </div>
          </div>

          <div className="product-detail__desc">
            {product.description?.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>

          {product.size && product.size.length > 0 && (
            <div className="product-detail__option">
              <label className="product-detail__label">Size</label>
              <select
                value={selectedSize}
                onChange={(e) => setSelectedSize(e.target.value)}
                className="product-detail__select"
              >
                <option value="">Select size</option>
                {product.size.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </div>
          )}

          {product.color && product.color.length > 0 && (
            <div className="product-detail__option">
              <label className="product-detail__label">Color</label>
              <div className="product-detail__colors">
                {product.color.map((c) => (
                  <button
                    key={c}
                    type="button"
                    className={`product-detail__color ${
                      selectedColor === c ? "is-active" : ""
                    }`}
                    onClick={() =>
                      setSelectedColor((prev) => (prev === c ? "" : c))
                    }
                    aria-pressed={selectedColor === c}
                  >
                    {c}
                  </button>
                ))}
              </div>
            </div>
          )}

          <div className="product-detail__actions">
            <div className="product-detail__qty">
              <button
                type="button"
                onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                className="qty__btn"
                aria-label="Decrease quantity"
              >
                −
              </button>
              <input
                className="qty__input"
                value={quantity}
                readOnly
                aria-label="Quantity"
              />
              <button
                type="button"
                onClick={() => setQuantity((q) => q + 1)}
                className="qty__btn"
                aria-label="Increase quantity"
              >
                +
              </button>
            </div>

            <button className="product-detail__add" onClick={handleAddToCart}>
              Add to Cart
            </button>
          </div>

          <div className="product-detail__info-block">
            <h3>Product Info</h3>
            <ul>
              {(product.Features || []).map((f, i) => (
                <li key={i}>{f}</li>
              ))}
            </ul>
          </div>
        </aside>
      </main>
      <Footer />
    </div>
  );
};

export default ProductDetail;
